<p-select #dropdown id={{id}} [(ngModel)]="selectedItemGroupName" [options]="optionsToLoad()" [virtualScroll]="true"
    [filter]="true" [virtualScrollItemSize]="35" [totalRecords]="totalRecordsToLoad()"
    [optionDisabled]="isAllOptionDisabled ? isDropdownOptionDisabled : false"
    [disabled]="isDropdownDisabled"
    [ariaLabel]="ariaLabel"
    (onShow)="clearSearch(dropdown)" (ngModelChange)="groupNameUpdated()"
    [ngModelOptions]="{standalone: true}" (keyup)="searchedText($event)">
    <!-- Template for selected item display -->
    <ng-template #selectedItem let-selectedOption>
        <div class="scrollHere">
            @if(this.dropdownName === this.sharedConstant.groupName){
            <span>{{selectedItemGroupName}}</span>
            }@else if(this.dropdownName === this.sharedConstant.instrumentGroup){
            <span>{{instGrpSelectedValue?.label}}</span>
            }
        </div>
    </ng-template>
    <!-- Template for each item in the dropdown list -->
    <ng-template let-empRecords pTemplate="item">
        <div class="scrollHere">
            @if(this.dropdownName === this.sharedConstant.groupName){
            <span>{{empRecords.value}}</span>
            }@else if(this.dropdownName === this.sharedConstant.instrumentGroup){
            <span>{{empRecords.label}}</span>
            }
        </div>
    </ng-template>
</p-select>
